import { KeyRound, X } from "lucide-react";
import { useState } from "react";
import { changePassword } from "../lib/api";

// Self-contained: a header button that opens a small change-password dialog.
export function ChangePasswordButton() {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const close = () => {
    setOpen(false);
    setCurrent("");
    setNext("");
    setError("");
    setDone(false);
  };

  const submit = async () => {
    if (next.length < 6) {
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      await changePassword({ currentPassword: current || undefined, newPassword: next });
      setDone(true);
      setCurrent("");
      setNext("");
    } catch (e) {
      setError(e instanceof Error ? e.message : "Đổi mật khẩu thất bại.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button
        className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-transparent bg-white text-slate-600 hover:border-line hover:bg-slate-50"
        type="button"
        aria-label="Đổi mật khẩu"
        title="Đổi mật khẩu"
        onClick={() => setOpen(true)}
      >
        <KeyRound size={18} aria-hidden="true" />
      </button>

      {open ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 p-4" onClick={close}>
          <div className="w-full max-w-sm rounded-lg border border-line bg-white shadow-panel" onClick={(event) => event.stopPropagation()}>
            <div className="flex items-center justify-between border-b border-line px-4 py-3">
              <h2 className="inline-flex items-center gap-2 text-sm font-bold">
                <KeyRound size={15} aria-hidden="true" /> Đổi mật khẩu
              </h2>
              <button type="button" aria-label="Đóng" className="text-muted hover:text-slate-700" onClick={close}>
                <X size={16} aria-hidden="true" />
              </button>
            </div>
            <div className="space-y-3 p-4">
              {done ? (
                <p className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm font-semibold text-emerald-700">
                  Đã đổi mật khẩu thành công.
                </p>
              ) : (
                <>
                  <div>
                    <label className="mb-1 block text-xs font-bold text-muted">Mật khẩu hiện tại (bỏ trống nếu chưa từng đặt)</label>
                    <input
                      className="h-10 w-full rounded-lg border border-line bg-slate-50 px-3 text-sm text-ink outline-none"
                      type="password"
                      value={current}
                      onChange={(event) => setCurrent(event.target.value)}
                      autoComplete="current-password"
                    />
                  </div>
                  <div>
                    <label className="mb-1 block text-xs font-bold text-muted">Mật khẩu mới (ít nhất 6 ký tự)</label>
                    <input
                      className="h-10 w-full rounded-lg border border-line bg-slate-50 px-3 text-sm text-ink outline-none"
                      type="password"
                      value={next}
                      onChange={(event) => setNext(event.target.value)}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          void submit();
                        }
                      }}
                      autoComplete="new-password"
                    />
                  </div>
                  {error ? <p className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm font-semibold text-red-700">{error}</p> : null}
                  <button
                    className="inline-flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-brand px-3 text-sm font-bold text-white hover:bg-blue-700 disabled:bg-slate-300"
                    type="button"
                    disabled={next.length < 6 || submitting}
                    onClick={submit}
                  >
                    {submitting ? "Đang đổi" : "Đổi mật khẩu"}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
